import React, { useEffect } from "react";

import {
    Button,
    FormControl,
    Typography
} from "../../../../../common/components/libs";
import { observer } from "mobx-react";
import { useStores } from "../../../../../hooks";
import { changeEventHandlerDecorator } from "../../../../../common/libs";

import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, InputLabel, MenuItem, OutlinedInput, useMediaQuery, useTheme, Select
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import style from "../style.module.css";
import { BookingFormType } from "../../../store/booking/forms";


const EditBookingScheduleForm = () => {
    const { bookingStore } = useStores();
    const { t } = useTranslation(["general", "booking"]);
    const forms = bookingStore.forms;
    const { open, current } = forms.forms[BookingFormType.editTimeSlots];
    const bookingSettings = bookingStore.bookingScheduleSettings;

    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));

    const step = [{ number: 15, time: "мин", value: 15 }, { number: 30, time: "мин", value: 30 },
        { number: 45, time: "мин", value: 45 }, { number: 1, time: "ч.", value: 60 },
        { number: 2, time: "ч.", value: 120 }, { number: 3, time: "ч.", value: 180 },
        { number: 4, time: "ч.", value: 240 }, { number: 5, time: "ч.", value: 300 },
        { number: 6, time: "ч.", value: 360 }];

    const time = [
        { hour: "00", min: "00" }, { hour: "00", min: "15" }, { hour: "00", min: "30" },
        { hour: "00", min: "45" }, { hour: "01", min: "00" },
        { hour: "01", min: "15" }, { hour: "01", min: "30" }, { hour: "01", min: "45" },
        { hour: "02", min: "00" }, { hour: "02", min: "15" },
        { hour: "02", min: "30" }, { hour: "02", min: "45" },
        { hour: "03", min: "00" }, { hour: "03", min: "15" }, { hour: "03", min: "30" },
        { hour: "03", min: "45" }, { hour: "03", min: "59" }, { hour: "04", min: "00" },
        { hour: "04", min: "15" }, { hour: "04", min: "30" }, { hour: "04", min: "45" },
        { hour: "05", min: "00" }, { hour: "05", min: "15" },
        { hour: "05", min: "30" }, { hour: "05", min: "45" },
        { hour: "06", min: "06" }, { hour: "06", min: "15" }, { hour: "06", min: "30" },
        { hour: "06", min: "45" }, { hour: "07", min: "00" },
        { hour: "07", min: "15" }, { hour: "07", min: "30" }, { hour: "07", min: "45" },
        { hour: "08", min: "00" }, { hour: "08", min: "15" },
        { hour: "08", min: "30" }, { hour: "08", min: "45" },
        { hour: "09", min: "00" }, { hour: "09", min: "15" }, { hour: "09", min: "30" },
        { hour: "09", min: "45" }, { hour: "10", min: "00" },
        { hour: "10", min: "15" }, { hour: "10", min: "30" }, { hour: "10", min: "45" },
        { hour: "11", min: "00" }, { hour: "11", min: "15" },
        { hour: "11", min: "30" }, { hour: "11", min: "45" },
        { hour: "12", min: "00" }, { hour: "12", min: "15" }, { hour: "12", min: "30" },
        { hour: "12", min: "45" }, { hour: "13", min: "00" },
        { hour: "13", min: "15" }, { hour: "13", min: "30" }, { hour: "13", min: "45" },
        { hour: "14", min: "00" }, { hour: "14", min: "15" },
        { hour: "14", min: "30" }, { hour: "14", min: "45" },
        { hour: "15", min: "00" }, { hour: "15", min: "15" }, { hour: "15", min: "30" },
        { hour: "15", min: "45" }, { hour: "16", min: "00" },
        { hour: "16", min: "15" }, { hour: "16", min: "30" }, { hour: "16", min: "45" },
        { hour: "17", min: "00" }, { hour: "17", min: "15" },
        { hour: "17", min: "30" }, { hour: "17", min: "45" },
        { hour: "18", min: "00" }, { hour: "18", min: "15" }, { hour: "18", min: "30" },
        { hour: "18", min: "45" }, { hour: "19", min: "00" },
        { hour: "19", min: "15" }, { hour: "19", min: "30" }, { hour: "19", min: "45" },
        { hour: "20", min: "00" }, { hour: "20", min: "15" },
        { hour: "20", min: "30" }, { hour: "20", min: "45" },
        { hour: "21", min: "00" }, { hour: "21", min: "15" }, { hour: "21", min: "30" },
        { hour: "21", min: "45" }, { hour: "22", min: "00" },
        { hour: "22", min: "15" }, { hour: "22", min: "30" }, { hour: "22", min: "45" },
        { hour: "23", min: "00" }, { hour: "23", min: "15" },
        { hour: "23", min: "30" }, { hour: "23", min: "45" },

    ]

    useEffect(() => {
        if (!current) return;
        bookingStore.setBookingScheduleSettings();

    }, [current]);

    if (!current) return;


    return (
        <Dialog
            open={open}
            onClose={() => {
                bookingStore.forms.closeForm(BookingFormType.editTimeSlots)
            }
            }
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"sm"}
            fullScreen={!isSm}
        >
            <DialogTitle id="form-dialog-title" className={style.deleteContent}>
                {t("menu:menuEditor.bookingSettings")}
            </DialogTitle>
            <DialogContent className={style.deleteContent}>
                {t("menu:menuEditor.bookingStep")}
                <FormControl fullWidth variant="outlined" className={style.selectItem}>
                    <InputLabel htmlFor="menuItemSchedule">
                        {t("menu:menuEditor.each")}
                    </InputLabel>
                    <Select
                        value={bookingSettings.step}
                        onChange={changeEventHandlerDecorator(function (bookingStep: number): void {
                            bookingStore.setScheduleItemStep(bookingStep)
                        })
                        }
                        input={<OutlinedInput
                            labelWidth={80}
                        />}
                    >
                        {
                            step.map(index => {
                                const string: string = index.number + " " + index.time;
                                return (
                                    <MenuItem value={index.value} key={index.number}>
                                        {string}
                                    </MenuItem>
                                )
                            })
                        }

                    </Select>
                </FormControl>

                <Typography>{t("menu:menuEditor.bookingInterval")}</Typography>

                <FormControl fullWidth variant="outlined" mb={5} mt={2}>
                    <InputLabel htmlFor="menuItemSchedule">
                        {t("general:from")}
                    </InputLabel>
                    <Select
                        value={`${bookingSettings.fromHour}:${bookingSettings.fromMinute}`}
                        onChange={changeEventHandlerDecorator(function (workingSchedule: string): void {
                            bookingStore.setScheduleItemSlot({
                                ...bookingSettings,
                                fromHour: parseInt(workingSchedule.split(":")[0]),
                                fromMinute: parseInt(workingSchedule.split(":")[1]),
                            });
                        })
                        }
                        input={<OutlinedInput
                            labelWidth={80}
                        />}
                    >
                        {
                            time.map(index => {
                                const hour = parseInt(index.hour);
                                const min = parseInt(index.min);
                                return (
                                    <MenuItem value={`${hour}:${min}`} key={`${hour}:${min}`}>
                                        {index.hour}:{index.min}
                                    </MenuItem>
                                )
                            })
                        }

                    </Select>
                </FormControl>
                <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="menuItemSchedule">
                        {t("general:to")}
                    </InputLabel>
                    <Select
                        value={`${bookingSettings.toHour}:${bookingSettings.toMinute}`}
                        onChange={changeEventHandlerDecorator(function (workingSchedule: string): void {
                            bookingStore.setScheduleItemSlot({
                                ...bookingSettings,
                                toHour: parseInt(workingSchedule.split(":")[0]),
                                toMinute: parseInt(workingSchedule.split(":")[1])
                            });
                        })
                        }
                        input={<OutlinedInput
                            labelWidth={80}
                        />}
                    >
                        {
                            time.map(index => {
                                const hour = parseInt(index.hour);
                                const min = parseInt(index.min);
                                return (
                                    <MenuItem value={`${hour}:${min}`} key={`${hour}:${min}`}>
                                        {index.hour}:{index.min}
                                    </MenuItem>
                                )
                            })
                        }
                    </Select>
                </FormControl>

            </DialogContent>

            <DialogActions>
                <div style={{ marginBottom: "30px" }}>
                    <Button
                        onClick={(e: React.MouseEvent) => bookingStore.forms.closeForm(BookingFormType.editTimeSlots)}
                        color="default">
                        {t("general:cancel")}
                    </Button>
                    <Button
                        color="primary"
                        onClick={() => bookingStore.forms.closeForm(BookingFormType.editTimeSlots)}
                    >
                        {t("general:save")}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
};

export default observer(EditBookingScheduleForm);
